export const iconFontAwesomeSocialThumbsUp = (
	<i className="fa-solid fa-thumbs-up"></i>
);
